import React, {useEffect, useState, useCallback} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useIsDesktop, useIsMobile} from '../../hooks';
import {Input, Button} from '..';
import {ROUTE_DOCS_EXTRACT, ROUTE_QR_CODE_SCANER} from '../../constants';
import qr from './images/qr.svg';
import './search_docs.scss';

const cleanSearch = (search: string) => search.toLowerCase().replace(/[^a-z0-9-]/g, '');

interface SearchDocsProps {
    defaultValue?: string;
    onFocus?: () => any;
    onSearch?: () => any;
}

export const SearchDocs: React.FC<SearchDocsProps> =
    ({
         defaultValue,
         onFocus,
         onSearch: handleSearch,
     }) => {
        const history = useHistory();
        const location = useLocation();
        const isDesktop = useIsDesktop();
        const isMobile = useIsMobile();

        const searchIcon = isDesktop ? '' : qr;

        const [search, setSearch] = useState('');

        useEffect(() => {
            if (defaultValue) setSearch(defaultValue);
        }, [defaultValue]);

        const handleSetSearch = useCallback((search: any) => setSearch(cleanSearch(search)), []);

        const onSearch = useCallback(() => {
            handleSearch && handleSearch();
            if (search !== '') {
                history.push(ROUTE_DOCS_EXTRACT + search);
            }
        }, [handleSearch, history, search]);

        const handleClickPostfixIcon = useCallback(() => {
            if (location.pathname === ROUTE_QR_CODE_SCANER) {
                window.location.reload();
            } else {
                history.push(ROUTE_QR_CODE_SCANER);
            }
        }, [location, history]);

        return (
            <div className="search-house-book">
                <div className="search-house-book__input">
                    <Input
                        className="text-lg leading-tight"
                        placeholder="Идентификатор документа"
                        onChange={handleSetSearch}
                        value={search}
                        height={isMobile ? 50 : 60}
                        postfixIcon={searchIcon}
                        onClickPostfixIcon={handleClickPostfixIcon}
                        onEnter={onSearch}
                        onFocus={onFocus}
                    />
                </div>
                <Button onClick={onSearch} size={isMobile ? 'small' : 'normal'}>
                    <div className="search-house-book__button">Проверить</div>
                </Button>
            </div>
        );
    };
